import { motion } from 'framer-motion';
import { 
  Link, Contact, Wifi, Mail, MessageSquare, MessageCircle, 
  Phone, MapPin, FileText, Calendar, DollarSign, Bitcoin,
  Download, Instagram, Twitter, Linkedin, Box, Layout, Palette, Trophy, Cpu
} from 'lucide-react';
import { QRType, useQRStore } from '@/stores/qrStore';
import { qrTypeConfig } from '@/lib/qr-utils';
import { cn } from '@/lib/utils';

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  Link,
  Contact,
  Wifi,
  Mail,
  MessageSquare,
  MessageCircle,
  Phone,
  MapPin,
  FileText,
  Calendar,
  DollarSign,
  Bitcoin,
  Download,
  Instagram,
  Twitter,
  Linkedin,
  Box,
  Layout,
  Palette,
  Trophy,
  Cpu,
};

export function QRTypeSelector() {
  const { currentQR, setType } = useQRStore();

  const types = Object.entries(qrTypeConfig) as [QRType, typeof qrTypeConfig[QRType]][];

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
        QR Code Type
      </h3>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {types.map(([type, config], index) => {
          const Icon = iconMap[config.icon] || Link;
          const isSelected = currentQR.type === type;

          return (
            <motion.button
              key={type}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.02 }}
              onClick={() => setType(type)}
              className={cn(
                'flex flex-col items-center justify-center gap-1.5 p-3 rounded-xl border transition-all duration-200',
                isSelected
                  ? 'border-primary bg-primary/10 text-primary glow-sm'
                  : 'border-border/50 hover:border-primary/50 hover:bg-muted/50'
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="text-xs font-medium">{config.label}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
